import React from "react";

import { BarChart } from "./";
import { getRgbaColors } from "@util/colors";

export default function PostopComplications({ data }) {
  if (!data) return null;

  const formattedData = {
    labels: data.complications.map((m) => m.name),
    datasets: [
      {
        data: data.complications.map((m) => m.count),
        backgroundColor: getRgbaColors(12),
      },
    ],
  };

  return <BarChart data={formattedData} />;
}
